import sunny from "../../images/weather/sunny.svg"
import stormy from "../../images/weather/stormy.svg";
import rainy from "../../images/weather/rainy.svg";
import cloudy from "../../images/weather/cloudy.svg";
import question from "../../images/weather/questionmark.svg";
import React from "react";
export const getAdvancementColor = (advancement, stepBehavior = false) => {
    if (stepBehavior) {
        return "#3394F6"
    }
    if (advancement >= 50 && advancement <= 100) {
        return '#52D783'
    } else {
        return '#FFB400'
    }
}

export const sliceText = (value, maxChar, defaultText) => {
    if (!!value && value.length > 0) {
        let text = value
        if (text.length > maxChar) {
            text = value.substring(0, maxChar) + "[...]";
        }
        return text
    } else {
        return defaultText
    }
}

// GET IMG
export const getWeatherImage = (weather) => {
    switch (weather) {
        case "sunny":
            return sunny;
        case "stormy":
            return stormy;
        case "rainy":
            return rainy;
        case "cloudy":
            return cloudy;
        default:
            return question;
    }
}
export const getImage = (img, defaultPicture) => {
    if (img !== null || img) {
        return `${process.env.REACT_APP_PROXYLESS_URL}${img}`
    } else {
        return defaultPicture
    }
}
export const getDifferenceBetweenTwoNumber = (start_number, finish_number) => {
    if (Number.isInteger(start_number) && Number.isInteger(finish_number)) {
        return Math.abs(finish_number - start_number)
    } else {
        return <p> Il semblerait que les valeurs passées ne sont pas des nombres </p>
    }
}
export const getPercent = (totalValue, partialValue) => {
    return parseFloat((partialValue / totalValue) * 100).toFixed(2);
}

export const getReversePercent = (totalValue, partialValue) => {
    return Math.abs(parseFloat(100 -(partialValue / totalValue) * 100).toFixed(2))
}

//FOR THE REDUX ACTION
export const checkErrorMessage = (e) => {
    return (e.response && e.response.data && e.response.data.message) ||
        e.message ||
        e.toString()
}
export const removeDuplicatesInArray = (array) => {
    return array.filter((value, index, self) =>
            index === self.findIndex((t) => (
                t.id === value.id
            ))
    )
}

export const getDateInFrench = (deadline) => {
    const notADate = "Aucune modification"
    const test = new Date(deadline)
    const date = test.toLocaleString("fr")
    if(!date){
        return
    }

    if (date === notADate) {
        return date
    } else {
        const year = date.slice(6, 11)
        const month = date.slice(3, 5)
        const day = date.slice(0, 2)
        return day + "-" + month + "-" + year
    }

}

export const getMonthYearFrench = () => {
    const monthInFrench = [
        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];

    const today = new Date();
    const month = monthInFrench[today.getMonth()];
    const year = today.getFullYear();

    return `${month} ${year}`;
}


